qw-promo-code {
  display: flex;
  justify-content: flex-start;
  height: 36px;
}

qw-promo-code.disable-promo > * {
  pointer-events: none;
  opacity: 0;
}

qw-promo-code.disable-promo {
  border-radius: 20px;
  position: relative;
}

qw-promo-code:before {
  content: '';
  display: block;
  width: 0;
  height: 0;
  visibility: hidden;
}
qw-promo-code.disable-promo:before {
  content: '';
  display: block;
  background-color: var(--qw-hotel-skeleton-light);
  position: absolute;
  border-radius: 10px;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.25);
}

qw-promo-code.disable-promo:after {
  content: '';
  display: block;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: #eee;
  background: linear-gradient(
    110deg,
    rgba(255, 255, 255, 0) 12%,
    white 17%,
    rgba(255, 255, 255, 0) 22%
  );
  background-size: 600% 100%;
  background-position-x: 40%;
  animation: 3s shine linear infinite;
  opacity: 0.4;
  z-index: 2;
}

qw-promo-code .booking--promo-code__wrapper {
  display: inline-flex;
  align-items: center;
  width: 100%;
  justify-content: space-between;
}

qw-promo-code .booking--promo-code__wrapper qw-input label {
  margin-bottom: 0;
}

qw-promo-code.hidden > * {
  display: none;
}

qw-promo-code .qw-button--icon {
  margin: 0 var(--qw-hotel-gap-sm);
  background-size: 12px;
  background-color: transparent;
  border-radius: 50%;
  border: none;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--qw-hotel-neutral-lightest);
}
qw-promo-code qw-input {
  width: 70%;
  border-radius: 5px;
  border: 1px solid #414445;
  height: 100%;
  margin-right: var(--qw-hotel-gap-md);
}
qw-promo-code qw-input label {
  height: 100%;
}
qw-promo-code qw-input.promo-code__label--to-add label {
  margin-bottom: 0;
}
qw-promo-code qw-input input {
  background-color: transparent;
  outline: none;
  font-family: var(--qw-hotel-font-family-r);
  padding: var(--qw-hotel-gap-xs) var(--qw-hotel-gap-lg);
}

qw-promo-code qw-input input::placeholder {
  color: var(--qw-hotel-label);
}

qw-promo-code qw-input .qw-input__label {
  margin-bottom: 0;
}

qw-promo-code .qw-button {
  width: 28%;
  height: 100%;
  background-color: var(--qw-hotel-primary-color);
  border-radius: 100px;
  border: solid 0px var(--qw-hotel-primary-color);
  font-family: var(--qw-hotel-font-family-b);
}

qw-promo-code .qw-button.qw-button--disabled {
  background-color: var(--qw-hotel-neutral-300) !important;
  color: var(--qw-hotel-neutral-lightest);
}

qw-promo-code qw-input .qw-input__caption {
  color: var(--qw-hotel-label);
  position: absolute;
  bottom: -5px;
  left: 0;
  transform: translateY(100%);
}

qw-promo-code qw-loading {
  transform: translate(-10px, 5px);
}

qw-promo-code .promo-code__label--to-remove {
  border: none;
  pointer-events: none;
}

qw-promo-code .promo-code__label--to-remove input {
  color: var(--qw-hotel-accent-label) !important;
  font-size: 16px;
}

qw-promo-code .qw-button--delete {
  border-radius: 0;
  border: none;
  background: url('#{$base-url}img/icons/bin.svg') no-repeat center;
  background-size: 18px;
}

@media only screen and (max-width: 1280px) {
  qw-promo-code qw-input {
    width: 60%;
  }
  qw-promo-code .booking--promo-code__wrapper {
    justify-content: flex-end;
  }

  qw-promo-code qw-input input {
    font-size: 15px;
    padding: 4px 16px;
  }
}

@media only screen and (max-width: 1024px) {
  qw-promo-code .booking--promo-code__wrapper {
    justify-content: flex-start;
  }
}

@media only screen and (max-width: 738px) {
  qw-promo-code.hidden {
    display: block;
  }
  qw-promo-code .qw-button {
    width: auto;
  }
}
